import React from 'react';
import {FormattedMessage} from 'react-intl';

import useStatusTabs from "../../../StatusesTab/useStatusTabs";
import {STATUS_TABS} from "../../../StatusesTab/statusTabsConfig";

import MobileStatusTab from "./components/MobileStatusTab";

import {blueColor, green500, orange500, red500, yellow700, purple700} from "assets/jss/main";

const THEME_DOT_COLOR = {
    yellow: yellow700,
    purple: purple700,
    default: blueColor,
    online: green500,
    warning: orange500,
    error: red500,
};

function MobileStatusesTab() {
    const {statusSelected, countRetrieved, loading, handleSelectStatus} = useStatusTabs();

    return (
        <div style={{display: 'flex', gap: '8px', overflowX: 'auto'}}>
            {STATUS_TABS.map(({status, countKey, labelId, theme, badgeTextColor}) => (
                <MobileStatusTab
                    key={status}
                    label={<FormattedMessage id={labelId}/>}
                    count={countRetrieved[countKey] ?? 0}
                    theme={theme}
                    badgeTextColor={badgeTextColor}
                    dotColor={THEME_DOT_COLOR[theme]}
                    selected={statusSelected === status}
                    onClick={() => handleSelectStatus(status)}
                    loading={loading}
                />
            ))}
        </div>
    );
}

export default MobileStatusesTab;
